import '@babel/polyfill';
jQuery(function ($) {
    console.log('gens.jsが読みこまれた');
    $('body').addClass('jquery-add-class');
});
const clientW = window.innerWidth;
const spSize = 768;
const clientSp = clientW < spSize;
const locatopmSwiper = () => new Swiper('.location-swiper', {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    centeredSlidesBounds: true,
    speed: 2000,
    spaceBetween: 0,
    autoplay: {
        delay: 1000,
        disableOnInteraction: false
    },
    navigation: {
        nextEl: ".locationSwiper-next",
        prevEl: ".locationSwiper-prev",
    }
});
locatopmSwiper();
const topRoomThumbnail = new Swiper('.topRoom-thumbnail', {
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    allowTouchMove: false
});
const topRoomSwiper = new Swiper('.topRooom-swiper', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 60,
    thumbs: {
        swiper: topRoomThumbnail
    },
    speed: 500
});
const roomImageSliders = document.querySelectorAll('.room-image-swiper');
roomImageSliders.forEach((slider, index) => {
    const sliderIndex = index + 1;
    const uniqueClass = `room-slider-${sliderIndex}`;
    new Swiper(slider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 2000,
        autoplay: {
            delay: 3500,
        },
        navigation: {
            nextEl: `.roomImage-next.${uniqueClass}`,
            prevEl: `.roomImage-prev.${uniqueClass}`,
        },
        pagination: {
            el: `.roomImage-pagination.${uniqueClass}`,
            clickable: true,
        }
    });
});
const singleVillaThumbnail = new Swiper('.single-room-thumbnail', {
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    allowTouchMove: false
});
const singleVillaSwiper = new Swiper('.single-room-swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    loop: true,
    thumbs: {
        swiper: singleVillaThumbnail
    },
    navigation: {
        nextEl: `.singleRoomImage-next`,
        prevEl: `.singleRoomImage-prev`,
    },
    speed: 1000
});
